import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * Project : HSS-Online
 * @class Auth Api Service
 * @author Waruna Gamage
 */
export class AuthService {
  constructor(private apiService: ApiService) {}

  /**
   * @method Register new user
   */
  registerUser(data: any) {
    return this.apiService.post('/register', null, data);
  }


  /**
   * @method login
   * @param username
   * @param password
   */
  login(data: any) {
    return this.apiService.post('/login', null, data);
  }

  /**
   * @method contact
   */
  contact(data: any) {
    return this.apiService.upload('/contactus', data);
  }

  /**
   * @method logout
   */
  logout() {
    localStorage.removeItem('userToken');
    localStorage.clear();
    sessionStorage.clear();
  }

  // public isAuthenticated(): Permission {
  //   if (localStorage.getItem('userToken') == null) {
  //     return new Permission(false, 'Unauthorized');
  //   } else {
  //     const accessToken = localStorage.getItem('userToken');
  //
  //     if (this.isTokenExpired(accessToken)) {
  //       return new Permission(false, 'Session Expired');
  //     }
  //
  //     return new Permission(true, '');
  //   }
  // }

  // getTokenExpirationDate(token: string): Date {
  //   const jwt = new JwtHelperService();
  //   const decoded = jwt.decodeToken(token);
  //
  //   if (decoded.exp === undefined) return null;
  //
  //   const date = new Date(0);
  //   date.setUTCSeconds(decoded.exp);
  //   return date;
  // }

  // isTokenExpired(token: string): boolean {
  //   const date = this.getTokenExpirationDate(token);
  //   if (date === null) return false;
  //   return !(date.valueOf() > new Date().valueOf());
  // }
}
